export default "__VITE_ASSET__DpzyP4Wm__"